import { render } from "./HowDoesItWork.vue?vue&type=template&id=f96b671e&scoped=true"
import script from "./HowDoesItWork.vue?vue&type=script&lang=js"
export * from "./HowDoesItWork.vue?vue&type=script&lang=js"

import "./HowDoesItWork.vue?vue&type=style&index=0&id=f96b671e&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f96b671e"]])

export default __exports__